const COLOR_FIELD_LABELS = {
  background_color: "Background Color",
  text_color: "Text Color",
  button_background_color: "Button Background Color",
  button_text_color: "Button Text Color",
};

export const THEME_SCREEN_SECTIONS = [
  {
    key: "start_screen",
    title: "Start Screen",
    fields: [
      "background_color",
      "text_color",
      "button_background_color",
      "button_text_color",
    ],
  },
  {
    key: "scene_nodes",
    title: "Scene Nodes",
    fields: [
      "button_background_color",
      "button_text_color",
      "text_color",
      "background_color",
    ],
  },
  {
    key: "question_nodes",
    title: "Question Nodes",
    fields: [
      "background_color",
      "text_color",
      "button_background_color",
      "button_text_color",
    ],
  },
  {
    key: "feedback_screens",
    title: "Feedback Screens",
    fields: [
      "background_color",
      "text_color",
      "button_background_color",
      "button_text_color",
    ],
  },
  {
    key: "final_summary_screen",
    title: "Final Summary Screen",
    fields: [
      "background_color",
      "text_color",
      "button_background_color",
      "button_text_color",
    ],
  },
  {
    key: "end_screen",
    title: "End Screen",
    fields: [
      "background_color",
      "text_color",
      "button_background_color",
      "button_text_color",
    ],
  },
];

const createEmptyScreenColors = () => ({
  background_color: "",
  text_color: "",
  button_background_color: "",
  button_text_color: "",
});

export const createEmptyThemeConfiguration = () =>
  THEME_SCREEN_SECTIONS.reduce((acc, section) => {
    acc[section.key] = createEmptyScreenColors();
    return acc;
  }, {});

// header_icon is not a screen: { url } when set, null when removed, absent when never set.
export const HEADER_ICON_KEY = "header_icon";
export const HEADER_ICON_CATEGORIES = ["insurance", "ciso_cyber"];

const normalizeHeaderIcon = (value) =>
  value && typeof value === "object" && value.url ? { url: value.url } : null;

export const normalizeThemeConfiguration = (data) => {
  const empty = createEmptyThemeConfiguration();

  if (!data || typeof data !== "object") {
    return empty;
  }

  const normalized = THEME_SCREEN_SECTIONS.reduce((acc, section) => {
    acc[section.key] = {
      ...empty[section.key],
      ...(data[section.key] || {}),
    };
    return acc;
  }, {});

  if (HEADER_ICON_KEY in data) {
    normalized[HEADER_ICON_KEY] = normalizeHeaderIcon(data[HEADER_ICON_KEY]);
  }

  return normalized;
};

export const buildThemeConfigurationPayload = (themeConfiguration) => {
  const normalized = normalizeThemeConfiguration(themeConfiguration);

  const payload = THEME_SCREEN_SECTIONS.reduce((acc, section) => {
    acc[section.key] = section.fields.reduce((screenAcc, fieldKey) => {
      screenAcc[fieldKey] = normalized[section.key][fieldKey] || "";
      return screenAcc;
    }, {});
    return acc;
  }, {});

  if (HEADER_ICON_KEY in normalized) {
    payload[HEADER_ICON_KEY] = normalized[HEADER_ICON_KEY];
  }

  return payload;
};

const HEADER_ICON_MAX_BYTES = 500 * 1024;
const HEADER_ICON_TYPES = ["image/svg+xml", "image/png", "image/webp"];
const HEADER_ICON_EXTENSIONS = [".svg", ".png", ".webp"];

export const HEADER_ICON_ERROR =
  "Header icon must be an SVG, PNG or WebP image, max 500 KB";

// Files are checked on type, extension and size. Strings are existing URLs and pass.
export const isValidHeaderIcon = (value) => {
  if (!value || typeof value === "string") return true;
  const name = (value.name || "").toLowerCase();
  return (
    HEADER_ICON_TYPES.includes(value.type) &&
    HEADER_ICON_EXTENSIONS.some((ext) => name.endsWith(ext)) &&
    value.size <= HEADER_ICON_MAX_BYTES
  );
};

export const getColorFieldLabel = (fieldKey) =>
  COLOR_FIELD_LABELS[fieldKey] || fieldKey;
